class SearchForm extends HTMLElement {
	constructor() {
		super()
		this.body = document.querySelector("body")
		this.form = this.querySelector(".search-form_form")
		this.input = this.querySelector(".form_input")
		this.openButton = document.querySelector(".header_nav-search")
		this.closeButton = document.querySelector(".search-form_header-close")

		this.initSearch()
	}

	initSearch() {
		this.openButton.addEventListener("click", (e) => {
			e.preventDefault()

			if (!this.body.classList.contains("search-show")) {
				this.open()
			} else {
				this.close()
			}
		})

		this.closeButton.addEventListener("click", (e) => {
			e.preventDefault()
			this.close()
		})

		this.input.addEventListener("keydown", (e) => {
			if (e.key === "Escape") {
				e.preventDefault()
				this.close()
			}
		})

		this.form.addEventListener("submit", (e) => {
			e.preventDefault()

			if (this.input.value !== "") {
				this.form.submit()
			}
		})
	}

	open() {
		this.body.classList.remove("burger-menu-open", "body-scroll-off")
		this.body.classList.remove("cart-drawer-show", "body-scroll-off", "backdrop-show")

		this.body.classList.add("search-show")
		this.input.focus()
	}

	close() {
		this.body.classList.remove("search-show")
	}
}

customElements.define("search-form", SearchForm)
